// extracted by mini-css-extract-plugin
export default {"element":"shapeElement_element__4jdbd","resize":"shapeElement_resize__b-xOV","svg":"shapeElement_svg__7Dzwg"};